"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSavedOffers2Claims = exports.setSavedOffers2Baskets = exports.setIsHoveredHotel = exports.setHotels2Collections = exports.setCompactResultsView = exports.removeSavedOfferFromBaskets = exports.openMapByResults = exports.openMapByHotel = exports.changeCompactResultsView = exports.addSavedOffer2Baskets = exports.addOffer2Claims = exports.addHotel2Collections = void 0;
var _reduxActions = require("redux-actions");
var _createActions = (0, _reduxActions.createActions)({
    changeCompactResultsView: function changeCompactResultsView(compact) {
      return compact;
    },
    openMapByHotel: function openMapByHotel(hotelID, offerID, queryID) {
      return {
        hotelID: hotelID,
        offerID: offerID,
        queryID: queryID
      };
    },
    openMapByResults: function openMapByResults(queryID) {
      return queryID;
    },
    setCompactResultsView: function setCompactResultsView(compact) {
      return compact;
    },
    addHotel2Collections: function addHotel2Collections(hotelID) {
      return hotelID;
    },
    setHotels2Collections: function setHotels2Collections(hotelsAsMap) {
      return hotelsAsMap;
    },
    addOffer2Claims: function addOffer2Claims(offerID) {
      return offerID;
    },
    setSavedOffers2Claims: function setSavedOffers2Claims(offersAsMap) {
      return offersAsMap;
    },
    addSavedOffer2Baskets: function addSavedOffer2Baskets(offerID) {
      return offerID;
    },
    removeSavedOfferFromBaskets: function removeSavedOfferFromBaskets(offerID) {
      return offerID;
    },
    setSavedOffers2Baskets: function setSavedOffers2Baskets(offersAsMap) {
      return offersAsMap;
    },
    setIsHoveredHotel: function setIsHoveredHotel(hotelID, isHovered) {
      return {
        hotelID: hotelID,
        isHovered: isHovered
      };
    }
  }, {
    prefix: 'TS_RESULTS'
  }),
  changeCompactResultsView = exports.changeCompactResultsView = _createActions.changeCompactResultsView,
  openMapByHotel = exports.openMapByHotel = _createActions.openMapByHotel,
  openMapByResults = exports.openMapByResults = _createActions.openMapByResults,
  setCompactResultsView = exports.setCompactResultsView = _createActions.setCompactResultsView,
  addHotel2Collections = exports.addHotel2Collections = _createActions.addHotel2Collections,
  setHotels2Collections = exports.setHotels2Collections = _createActions.setHotels2Collections,
  addOffer2Claims = exports.addOffer2Claims = _createActions.addOffer2Claims,
  setSavedOffers2Claims = exports.setSavedOffers2Claims = _createActions.setSavedOffers2Claims,
  addSavedOffer2Baskets = exports.addSavedOffer2Baskets = _createActions.addSavedOffer2Baskets,
  removeSavedOfferFromBaskets = exports.removeSavedOfferFromBaskets = _createActions.removeSavedOfferFromBaskets,
  setSavedOffers2Baskets = exports.setSavedOffers2Baskets = _createActions.setSavedOffers2Baskets,
  setIsHoveredHotel = exports.setIsHoveredHotel = _createActions.setIsHoveredHotel;